import type { Components, Theme } from '@mui/material'

const dialogActions: Components<Omit<Theme, 'components'>>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2),
    }),
  },
}

export default dialogActions
